import { FC, ReactElement, SVGProps } from 'react'

type PictogramSize = 'extra-small' | 'small' | 'medium' | 'large'

export type PictogramProps = {
    size?: PictogramSize
}

const sizeInPx = (size: PictogramSize): number => {
    switch (size) {
        case 'extra-small':
            return 32
        case 'small':
            return 40
        case 'medium':
            return 56
        case 'large':
            return 80
    }
}

/**
 * Create a Pictogram component with a specific SVG
 * For use only within the DS—do not export out of the DS
 */
export default function createPictogram(
    PictogramComponent: FC<SVGProps<unknown>>
): (props: PictogramProps) => ReactElement<PictogramProps> {
    return function PictogramCreator({ size = 'large' }: PictogramProps): ReactElement<PictogramProps> {
        const pixels = sizeInPx(size)

        // Viewbox needs to be set to ensure proper scaling and matches the coordinate space of
        // the image, so it's always 80x80px, regardless of the size we want to scale to.
        //
        // More info:  https://css-tricks.com/scale-svg/
        return <PictogramComponent viewBox="0 0 80 80" width={pixels} height={pixels} />
    }
}

export type PictogramType = ReturnType<typeof createPictogram>
